export default [
	{
		name: 'Question',
		pedigree_type: 'Question'
	},
	{
		name: 'Article',
		pedigree_type: 'Article'
	},
	{
		name: 'Panel',
		pedigree_type: 'Panel'
	}
]